import React, { ReactNode, FunctionComponent } from 'react';

export type CtaBoxTitleProps = {
    children: ReactNode;
    qaRole?: string;
};

const CtaBoxTitle: FunctionComponent<CtaBoxTitleProps> = ({ children, qaRole }) => {
    // todo: check the children validation
    if (!children) {
        return null;
    }

    return (
        <h1 className="cta-box__title" data-qa-role={qaRole || 'cta-box-title'}>
            {children}
        </h1>
    );
};

export default CtaBoxTitle;
